import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NormatividadService } from 'src/app/servicios/normatividad.service';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { ServiceService } from 'src/app/servicios/service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Loading } from 'src/app/Class/Loading';
declare var $:any;

@Component({
  selector: 'app-listado-norma',
  templateUrl: './listado-norma.component.html',
  styleUrls: ['./listado-norma.component.css']
})

export class ListadoNormaComponent implements OnInit, OnDestroy  {
  public normas: any = [];
  public tipo: any;
  public interna:any;
  public success: any;
  estadoN: Boolean;
  public serve: any;
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = DTConfig.dtConf;
  public dtTrigger: Subject<any> = new Subject();
  public idTipo: number;
  
  constructor( private normatividadService: NormatividadService, private servi:ServiceService, private router:ActivatedRoute, private route: Router, public loading: Loading) {
   
    this.loading.estado = true;
    this.serve = this.normatividadService.getServe();
    
    this.router.params
    .subscribe(parametros => {
      this.idTipo = parametros['id'];

      this.normatividadService.getListado(this.idTipo)
      .subscribe( data => {
          this.success = data['success'];
          this.normas = data['normas']; 
          this.tipo = data['tipo'];
          this.interna=data['intern'];
          if(this.success == false ){
            Swal.fire({ type: 'error', title:'Error', text: 'Tipo de norma no disponible', showConfirmButton: false, timer: 1500 });    
            this.route.navigate(['/dashboard']);
          }
          this.loading.estado = false;

           this.rerender();

      });
    });
  }

  ngOnInit(): void {}
  

  publicarOcultar(id, i) {
    this.normas.indexOf(i);
    Swal.fire({
      title:'Publicar/Ocultar',
      text: '¿Desea publicar/ocultar?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      reverseButtons: true
    })
    .then((result) => {
      if (result.value) {
        this.normatividadService.publicarOcultarN(id).subscribe(data => {
          if ( data ['success']) {
            this.normas[i].publico = data['nuevoEstado'];
            this.normas[i].fecha_publicacion=data['nuevaFecha']
            Swal.fire('Publicar', 'El estado se ha cambiado exitosamente', 'success' );
          } 
          else {
            Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
          }
        });
      }
    });
  }

  cambiarEstado(id, i) {
    this.normas.indexOf(i);
    Swal.fire({
      title:'Eliminar',
      text: '¿Desea cambiar eliminar?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      reverseButtons: true
    })
    .then((result) => {
      if (result.value) {
        this.normatividadService.cambiarEstadoN(id).subscribe(data => {
          if ( data ['success']) {
            this.normas[i].estado = data['nuevoEstado'];
            Swal.fire('Eliminar', 'Se ha eliminado exitosamente', 'success' );
          } 
          else {
            Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
          }
        });
      }
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}
